import { Event } from "@/interfaces/Event"

export class GlobalHelpers {
    constructor() {}

    public static formatDate(dateTime: Date): string {
        let dateString = ''
        const date = new Date(dateTime)
        dateString += date.toLocaleDateString('fr', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
        dateString += ' à '
        dateString += date.toLocaleTimeString('fr', {
            hour: '2-digit',
            minute: '2-digit'
        })
        return dateString
    }

    public static formatEventAddress(event: Event): string|false {
        if (event.place && event.place.length) {
            const place = event.place[0]
            const placeArray = []
            if (place.name) placeArray.push(place.name)
            if (place.address) placeArray.push(place.address)
            if (place.address2) placeArray.push(place.address2)
            if (place.zipcode) placeArray.push(place.zipcode)
            if (place.city) placeArray.push(place.city)
            if (placeArray.length) {
                return placeArray.join(' ')
            }
        }
        return false
    }
}